import { render, staticRenderFns } from "./ManageOrgs.vue?vue&type=template&id=94f6cc3e&lang=pug&"
import script from "./ManageOrgs.vue?vue&type=script&lang=js&"
export * from "./ManageOrgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports